<div class="statistics-container">
  <div class="queue-refresh">
    <mat-icon class="queue-refresh-icon" [class.spinning]="queueLoading">autorenew</mat-icon>
    <span *ngIf="queueLoading">Odświeżanie…</span>
    <span *ngIf="!queueLoading">Następne odświeżenie za {{ queueCountdown }}s</span>
  </div>
  <div class="queue-status">
    <div class="queue-card queue-card-allegro">
      <div class="queue-icon"><mat-icon>shopping_cart</mat-icon></div>
      <div class="queue-info">
        <div class="queue-label">Kolejka Allegro</div>
        <div class="queue-value" [class.queue-active]="queueCounts.needsReload > 0">{{ queueCounts.needsReload | number }}</div>
        <div class="queue-rate" *ngIf="allegroRate">
          <mat-icon class="queue-rate-icon">{{ allegroRate > 0 ? 'trending_down' : 'trending_up' }}</mat-icon>
          {{ allegroRate > 0 ? '-' : '+' }}{{ allegroRate > 0 ? allegroRate : -allegroRate }} szt/min
        </div>
        <div class="queue-eta" *ngIf="allegroEta">
          <mat-icon class="queue-rate-icon">schedule</mat-icon>
          {{ allegroEta }}
        </div>
        <div class="queue-sublabel">needsReload</div>
      </div>
    </div>
    <div class="queue-card queue-card-inpost">
      <div class="queue-icon"><mat-icon>local_shipping</mat-icon></div>
      <div class="queue-info">
        <div class="queue-label">Kolejka InPost</div>
        <div class="queue-value" [class.queue-active]="queueCounts.needsInpostReload > 0">{{ queueCounts.needsInpostReload | number }}</div>
        <div class="queue-rate" *ngIf="inpostRate">
          <mat-icon class="queue-rate-icon">{{ inpostRate > 0 ? 'trending_down' : 'trending_up' }}</mat-icon>
          {{ inpostRate > 0 ? '-' : '+' }}{{ inpostRate > 0 ? inpostRate : -inpostRate }} szt/min
        </div>
        <div class="queue-eta" *ngIf="inpostEta">
          <mat-icon class="queue-rate-icon">schedule</mat-icon>
          {{ inpostEta }}
        </div>
        <div class="queue-sublabel">needsInpostReload</div>
      </div>
    </div>
    <div class="queue-card queue-card-ratelimit" *ngIf="inpostRateLimit?.lastUpdated">
      <div class="queue-icon"><mat-icon>speed</mat-icon></div>
      <div class="queue-info">
        <div class="queue-label">InPost Rate Limit</div>
        <div class="queue-value" [class.queue-active]="inpostRateLimit.remaining !== null && inpostRateLimit.remaining < 50"
             [class.queue-warning]="inpostRateLimit.remaining !== null && inpostRateLimit.remaining < 20">
          {{ inpostRateLimit.remaining !== null ? inpostRateLimit.remaining : '?' }} / {{ inpostRateLimit.limit !== null ? inpostRateLimit.limit : '?' }}
        </div>
        <div class="queue-rate" *ngIf="inpostRateLimit.velocity !== null && inpostRateLimit.velocity !== undefined">
          <mat-icon class="queue-rate-icon">trending_up</mat-icon>
          {{ inpostRateLimit.velocity }} req/min
        </div>
        <div class="queue-rate" *ngIf="inpostRateLimit.reset">
          <mat-icon class="queue-rate-icon">update</mat-icon>
          Reset: {{ inpostRateLimit.reset * 1000 | date:'HH:mm:ss' }}
        </div>
        <div class="queue-sublabel">remaining / limit</div>
      </div>
    </div>
  </div>

  <div class="range-selector">
    <mat-button-toggle-group [value]="selectedRange" (change)="onRangeChange($event)">
      <mat-button-toggle value="1h">1h</mat-button-toggle>
      <mat-button-toggle value="6h">6h</mat-button-toggle>
      <mat-button-toggle value="24h">24h</mat-button-toggle>
      <mat-button-toggle value="7d">7d</mat-button-toggle>
      <mat-button-toggle value="30d">30d</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <mat-tab-group [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">
    <!-- Tab 1: Queue sizes -->
    <mat-tab label="Kolejki">
      <div class="chart-container">
        <canvas id="queueChart"></canvas>
      </div>
      <div class="legend">
        <span class="legend-item"><span class="legend-dot" style="background:#ff9800"></span> Allegro (needsReload)</span>
        <span class="legend-item"><span class="legend-dot" style="background:#4caf50"></span> InPost (needsInpostReload)</span>
        <span class="legend-item"><span class="legend-dot" style="background:#e53935; border-radius:0; width:2px; height:12px"></span> Restart</span>
        <span class="legend-item"><span class="legend-dot" style="background:#8e24aa; border-radius:0; width:2px; height:12px"></span> Zmiana konfiguracji</span>
      </div>
    </mat-tab>

    <!-- Tab 2: Allegro item metrics -->
    <mat-tab label="Allegro - Aukcje">
      <div class="chart-container">
        <canvas id="allegroMetricsChart"></canvas>
      </div>
      <div class="legend">
        <span class="legend-item"><span class="legend-dot" style="background:#4caf50"></span> Utworzone</span>
        <span class="legend-item"><span class="legend-dot" style="background:#2196f3"></span> Zaktualizowane</span>
        <span class="legend-item"><span class="legend-dot" style="background:#f44336"></span> Bledy</span>
        <span class="legend-item"><span class="legend-dot" style="background:#9e9e9e"></span> Pominiete</span>
        <span class="legend-item"><span class="legend-dot" style="background:#d32f2f"></span> Bledy aktualizacji</span>
        <span class="legend-item"><span class="legend-dot" style="background:#e53935; border-radius:0; width:2px; height:12px"></span> Restart</span>
        <span class="legend-item"><span class="legend-dot" style="background:#8e24aa; border-radius:0; width:2px; height:12px"></span> Zmiana konfiguracji</span>
      </div>
    </mat-tab>

    <!-- Tab 2: InPost item metrics -->
    <mat-tab label="InPost - Oferty">
      <div class="chart-container">
        <canvas id="inpostMetricsChart"></canvas>
      </div>
      <div class="legend">
        <span class="legend-item"><span class="legend-dot" style="background:#4caf50"></span> Utworzone</span>
        <span class="legend-item"><span class="legend-dot" style="background:#2196f3"></span> Zaktualizowane</span>
        <span class="legend-item"><span class="legend-dot" style="background:#f44336"></span> Bledy</span>
        <span class="legend-item"><span class="legend-dot" style="background:#9e9e9e"></span> Pominiete</span>
        <span class="legend-item"><span class="legend-dot" style="background:#d32f2f"></span> Bledy aktualizacji</span>
        <span class="legend-item"><span class="legend-dot" style="background:#e53935; border-radius:0; width:2px; height:12px"></span> Restart</span>
        <span class="legend-item"><span class="legend-dot" style="background:#8e24aa; border-radius:0; width:2px; height:12px"></span> Zmiana konfiguracji</span>
      </div>
    </mat-tab>

    <!-- Tab 3: InterCars API (stockInventoryUpdateCron) -->
    <mat-tab label="InterCars - API">
      <div class="chart-container">
        <canvas id="intercarsApiChart"></canvas>
      </div>
      <div class="legend">
        <span class="legend-item"><span class="legend-dot" style="background:#2196f3"></span> Sprawdzone (API)</span>
        <span class="legend-item"><span class="legend-dot" style="background:#ff9800"></span> Zmienione</span>
        <span class="legend-item"><span class="legend-dot" style="background:#e53935; border-radius:0; width:2px; height:12px"></span> Restart</span>
        <span class="legend-item"><span class="legend-dot" style="background:#8e24aa; border-radius:0; width:2px; height:12px"></span> Zmiana konfiguracji</span>
      </div>
    </mat-tab>

    <!-- Tab 4: InterCars CSV imports -->
    <mat-tab label="InterCars - CSV">
      <div class="chart-container">
        <canvas id="intercarsCsvChart"></canvas>
      </div>
      <div class="legend">
        <span class="legend-item"><span class="legend-dot" style="background:#4caf50"></span> Nowe produkty</span>
        <span class="legend-item"><span class="legend-dot" style="background:#2196f3"></span> Zaktualizowane</span>
        <span class="legend-item"><span class="legend-dot" style="background:#e53935; border-radius:0; width:2px; height:12px"></span> Restart</span>
        <span class="legend-item"><span class="legend-dot" style="background:#8e24aa; border-radius:0; width:2px; height:12px"></span> Zmiana konfiguracji</span>
      </div>
    </mat-tab>

    <!-- Tab 4: Job executions -->
    <mat-tab label="Uruchomienia">
      <div class="chart-container">
        <canvas id="processingChart"></canvas>
      </div>
      <div class="legend">
        <span class="legend-item"><span class="legend-dot" style="background:#2196f3"></span> InterCars</span>
        <span class="legend-item"><span class="legend-dot" style="background:#ff9800"></span> Allegro</span>
        <span class="legend-item"><span class="legend-dot" style="background:#4caf50"></span> InPost</span>
        <span class="legend-item"><span class="legend-dot" style="background:#e53935; border-radius:0; width:2px; height:12px"></span> Restart</span>
        <span class="legend-item"><span class="legend-dot" style="background:#8e24aa; border-radius:0; width:2px; height:12px"></span> Zmiana konfiguracji</span>
      </div>
    </mat-tab>

    <!-- Tab 5: Success / Failures -->
    <mat-tab label="Sukces / Bledy">
      <div class="chart-container">
        <canvas id="successFailChart"></canvas>
      </div>
    </mat-tab>

    <!-- Tab 6: Duration -->
    <mat-tab label="Czas trwania">
      <div class="chart-container">
        <canvas id="durationChart"></canvas>
      </div>
    </mat-tab>

    <!-- Tab 8: Critical errors table -->
    <mat-tab label="Bledy krytyczne">
      <div class="critical-errors-header" *ngIf="criticalErrors.length > 0">
        <mat-icon color="warn">error</mat-icon>
        <span>{{ criticalErrors.length }} blad(ow) — nieudane aktualizacje ofert</span>
      </div>
      <div *ngIf="criticalErrors.length === 0" class="no-errors">
        <mat-icon>check_circle</mat-icon>
        <span>Brak bledow krytycznych</span>
      </div>
      <table mat-table [dataSource]="criticalErrors" class="recent-table mat-elevation-z2" *ngIf="criticalErrors.length > 0">
        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef>Czas</th>
          <td mat-cell *matCellDef="let e">{{ e.createdAt | date:'yyyy-MM-dd HH:mm:ss' }}</td>
        </ng-container>

        <ng-container matColumnDef="provider">
          <th mat-header-cell *matHeaderCellDef>Provider</th>
          <td mat-cell *matCellDef="let e" [ngClass]="'provider-' + e.provider">{{ e.provider }}</td>
        </ng-container>

        <ng-container matColumnDef="TK">
          <th mat-header-cell *matHeaderCellDef>TK</th>
          <td mat-cell *matCellDef="let e">{{ e.TK }}</td>
        </ng-container>

        <ng-container matColumnDef="offerId">
          <th mat-header-cell *matHeaderCellDef>ID oferty</th>
          <td mat-cell *matCellDef="let e">{{ e.offerId | slice:0:20 }}</td>
        </ng-container>

        <ng-container matColumnDef="errorMessage">
          <th mat-header-cell *matHeaderCellDef>Blad</th>
          <td mat-cell *matCellDef="let e" class="error-cell">{{ e.errorMessage | slice:0:120 }}</td>
        </ng-container>

        <ng-container matColumnDef="unpublished">
          <th mat-header-cell *matHeaderCellDef>Wycofano</th>
          <td mat-cell *matCellDef="let e">
            <mat-icon *ngIf="e.unpublished" style="color:#4caf50">check_circle</mat-icon>
            <mat-icon *ngIf="!e.unpublished" style="color:#f44336">cancel</mat-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="resolved">
          <th mat-header-cell *matHeaderCellDef>Rozwiazano</th>
          <td mat-cell *matCellDef="let e">
            <mat-icon *ngIf="e.resolved" style="color:#4caf50">check_circle</mat-icon>
            <mat-icon *ngIf="!e.resolved" style="color:#ff9800">pending</mat-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let e">
            <button mat-icon-button *ngIf="!e.resolved" (click)="resolveCriticalError(e._id)" matTooltip="Oznacz jako rozwiazane">
              <mat-icon>done</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="criticalErrorColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: criticalErrorColumns;" [class.resolved-row]="row.resolved"></tr>
      </table>
    </mat-tab>

    <!-- Tab 9: Recent events table -->
    <mat-tab label="Ostatnie zdarzenia">
      <table mat-table [dataSource]="recentEvents" class="recent-table mat-elevation-z2">
        <ng-container matColumnDef="startTime">
          <th mat-header-cell *matHeaderCellDef>Czas</th>
          <td mat-cell *matCellDef="let e">{{ e.startTime | date:'yyyy-MM-dd HH:mm:ss' }}</td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Typ</th>
          <td mat-cell *matCellDef="let e">{{ e.type }}</td>
        </ng-container>

        <ng-container matColumnDef="jobName">
          <th mat-header-cell *matHeaderCellDef>Zadanie</th>
          <td mat-cell *matCellDef="let e">{{ e.jobName }}</td>
        </ng-container>

        <ng-container matColumnDef="provider">
          <th mat-header-cell *matHeaderCellDef>Provider</th>
          <td mat-cell *matCellDef="let e" [ngClass]="'provider-' + e.provider">{{ e.provider }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let e" [ngClass]="'status-' + e.status">{{ e.status }}</td>
        </ng-container>

        <ng-container matColumnDef="durationMs">
          <th mat-header-cell *matHeaderCellDef>Czas trwania</th>
          <td mat-cell *matCellDef="let e">{{ formatDuration(e.durationMs) }}</td>
        </ng-container>

        <ng-container matColumnDef="errorMessage">
          <th mat-header-cell *matHeaderCellDef>Blad</th>
          <td mat-cell *matCellDef="let e">{{ e.errorMessage ? (e.errorMessage | slice:0:80) : '-' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </mat-tab>
  </mat-tab-group>
</div>
